import { Box, Flex, Heading, Text, useBreakpointValue } from "@chakra-ui/react"
import { useRouter } from "next/router"
import { Category } from "../../../../api-clients/product-api-v1"
import { brands, pages } from "../../../../common/constants/constants"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import { ChakraNextLinkButton } from "../../../shared/ChakraNextLinkButton"
import CustomImage from "../../../shared/CustomImage"
import { CArrowRight } from "../../../shared/Icons"

type Props = {
  series: Category
  isOdd: boolean
}

const SeriesTile = ({ series, isOdd }: Props) => {
  const { t } = useBrandedTranslation()
  const { query } = useRouter()
  const brand = String(query.brand)

  // Split out the brand from the series name for styling purposes
  const seriesNameWords = series?.name?.split(" ") ?? []
  const brandTitle = seriesNameWords.shift() ?? ""
  const seriesTitle = seriesNameWords.join(" ") ?? ""

  // Load different image size by breakpoint, pending PO approval
  const imageSize = useBreakpointValue({ base: "medium", sm: "medium" })
  const imgSrc = series.images?.[1]?.[imageSize]

  return (
    <Flex
      w={{ base: "100%", sm: "180", md: "202" }}
      h={{ base: "104.5", sm: "87", md: "98" }}
      bgColor={isOdd ? "black" : "gray.100"}
      color={isOdd ? "white" : "black"}
      flexDirection={{ base: "column-reverse", sm: "row" }}
    >
      <Flex
        flexDirection="column"
        alignItems="flex-start"
        p={{ base: "6", sm: "8" }}
        w={{ base: "100%", sm: "50%" }}
        h="100%"
        gap="2"
      >
        <Heading as="h3" fontSize="5xl" textTransform="uppercase" lineHeight="9">
          <Text fontWeight={brands[brand].subTitleFontWeight}>{brandTitle}</Text>
          <Text fontWeight={brands[brand].mainTitleFontWeight}>{seriesTitle}</Text>
        </Heading>
        <Text fontWeight="normal" fontSize="md" lineHeight="6">
          {series.slogan}
        </Text>
        <ChakraNextLinkButton
          variant="textLink"
          px="0"
          href={`/${pages.SERIES}/${series.id}`}
          color="inherit"
          label={t("carousel-series-tile-link", { seriesName: series.name })}
          leftIcon={<CArrowRight />}
        />
      </Flex>
      <Box w={{ base: "100%", sm: "50%" }} h={{ base: "41", sm: "100%" }}>
        <CustomImage
          src={imgSrc}
          alt={`${series.name} bathroom series image`}
          fit="cover"
          loading="lazy"
          width={{ base: "100%", sm: "90", md: "101" }}
          h={{ base: "100%", sm: "87", md: "98" }}
        />
      </Box>
    </Flex>
  )
}

export default SeriesTile
